require('./scrollInit');
require('./nav');
require('./scrollBehaviour');
require('./plugins/counter');

require('./global');

require('./cover');
require('./sidebar');

require('./topic-1/section-1-1');
require('./topic-1/section-1-3');
require('./topic-1/section-1-4');
require('./topic-2/section-2-1');
require('./topic-2/section-2-2');
require('./topic-2/section-2-3');

require('./topic-3/section-3-1');
require('./topic-3/section-3-3');
require('./topic-3/section-3-4');

/* topic4 */
require('./topic-4/topic-4-1');
require('./topic-4/topic-4-2');
require('./topic-4/topic-4-3');
require('./topic-4/topic-4-4');
require('./topic-4/topic-4-5');
require('./topic-4/topic-4-6');
require('./topic-4/topic-4-7');

/* topic5 */
require('./topic-5/topic-5');

/* topic6 */
require('./topic-6/topic-6');